// extracted by mini-css-extract-plugin
export default {"wrapper":"campaignSelector_wrapper__6d5WU"};